import { render, staticRenderFns } from "./CoinNetwork.vue?vue&type=template&id=27c2f44c&scoped=true&"
import script from "./CoinNetwork.vue?vue&type=script&lang=ts&"
export * from "./CoinNetwork.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetwork.vue?vue&type=style&index=0&id=27c2f44c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2f44c",
  null
  
)

export default component.exports